import { makeStyles, useTheme } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";

import { AIProvider } from "@dashboard-v3/api";

const PROVIDER_COLORS: Record<string, string> = {
  openai: "#0f766e",
  "azure-openai": "#1d4ed8",
  anthropic: "#b45309",
  gemini: "#6d28d9",
  mistral: "#c2410c",
  openrouter: "#4338ca",
  deepseek: "#0369a1",
};

interface Props {
  provider: AIProvider;
  small?: boolean;
}

export default function ProviderAvatar({ provider, small = false }: Props) {
  const theme = useTheme();
  const classes = useStyles();
  const color = PROVIDER_COLORS[provider.id] || theme.palette.primary.main;
  const style = { color, backgroundColor: alpha(color, 0.1) };
  const className = small
    ? `${classes.avatar} ${classes.small}`
    : classes.avatar;

  return (
    <span className={className} style={style}>
      {getInitials(provider.displayName)}
    </span>
  );
}

function getInitials(name: string) {
  return name
    .split(" ")
    .map(word => word.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

const useStyles = makeStyles({
  avatar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "none",
    width: 40,
    height: 40,
    borderRadius: 10,
    fontWeight: 500,
    fontSize: 15,
  },
  small: {
    width: 24,
    height: 24,
    borderRadius: 6,
    fontSize: 11,
  },
});
